const UnknownCode = 'UNKNOWN';
const UnknownText = 'Awaiting confirmation from the operator';

const getTourBookingStatusText = (bookingResponse) => {
  if (!bookingResponse) {
    return undefined;
  }

  const code = (bookingResponse.bookingStatusCode || '').toString().toUpperCase();
  if (code === UnknownCode) {
    return UnknownText;
  }

  return bookingResponse.bookingStatus;
};

export default getTourBookingStatusText;
